export const NETWORK_QUALITY_SCORE = {
  noConnection: 0,
  poor: 1,
  good: 2,
  excellent: 3,
};
